import { hasProductAccess, type ProductFeatureMap } from '@tfa/shared'
import { useAuth } from './useAuth'

/**
 * Прятать ли кураторский интерфейс от клиента.
 *
 * #534: в Клубе куратора нет by design — назначить его нельзя (`requiresCurator`
 * на бэке), трекинг ответственности на клубных клиентов не заводится, общение
 * ведёт ИИ. А приложение всё равно показывало карточку куратора, его
 * комментарии в питании, показателях и тренировках и тумблер их дублирования в
 * настройках: кнопки, за которыми никого нет.
 *
 * Правило берём из матрицы доступа (`PRODUCT_ACCESS.*.curator`), а не из
 * сравнения с 'CLUB', — чтобы следующий продукт без куратора не пришлось
 * дописывать по всем экранам.
 *
 * Прячем ТОЛЬКО при явно известном продукте. У куратора в режиме просмотра
 * клиента `product` в сессии свой, не клиентский, и правило «нет доступа →
 * прятать» выключило бы кураторский UI ему самому.
 */
export function useCuratorHidden(): boolean {
  const { user } = useAuth()
  const u = user as { product?: string | null; access?: Partial<ProductFeatureMap> | null } | undefined
  const product = u?.product ?? null
  // Три тарифа: карта тарифа с сервера (переопределения админа), дефолты — запасной путь.
  return !!product && !hasProductAccess(product, 'curator', u?.access)
}
